const ZDANIA17 = [
  {
    name: "[5klasa] Angielski : częsci ciała i inne",
    lang: 'en',
    zdania: [
      {
        pl: "głowa",
        de: "head",
      },
      {
        pl: "ucho",
        de: "ear",
      },
      {
        pl: "ramiono",
        de: "shoulder",
      },
      {
        pl: "włosy",
        de: "hair",
      },
      {
        pl: "nos",
        de: "nose",
      },
      {
        pl: "usta",
        de: "mouth",
      },
      {
        pl: "throat",
        de: "gardło",
      },
      {
        pl: "klatka piersiowa",
        de: "chest",
      },
      {
        pl: "kolano",
        de: "knee",
      },
      {
        pl: "noga",
        de: "leg",
      },
      {
        pl: "kostka",
        de: "anke",
      },
      {
        pl: "palec u nogi",
        de: "toe",
      },
      {
        pl: "stopa",
        de: "foot",
      },
      {
        pl: "stomach",
        de: "brzuch",
      },
      {
        pl: "palec (u ręki)",
        de: "finger",
      },
      {
        pl: "nadgarstek",
        de: "wrist",
      },
      {
        pl: "łokieć",
        de: "elbow",
      },
      {
        pl: "ramię",
        de: "arm",
      },
      {
        pl: "kciuk",
        de: "thumb",
      },
      {
        pl: "ból (nagły, ostry, trudno zignorować taki ból)",
        de: "pain",
      },
      {
        pl: "bolesny",
        de: "painful",
      },
      {
        pl: "bół (łagodniejszy, ciągły, czasami ignorowany)",
        de: "ache",
      },
      {
        pl: "boleć (łagdniejszy, ciągły)",
        de: "to ache",
      },
      {
        pl: "łydka",
        de: "calf",
      },
      {
        pl: "udo",
        de: "thigh",
      },
      {
        pl: "nerka",
        de: "kidney",
      },
      {
        pl: "wątroba",
        de: "liver",
      },
      {
        pl: "płuca",
        de: "lungs",
      },
      {
        pl: "obgryzać twoje paznokcie",
        de: "to bite your nails",
      },
      {
        pl: "wydmuchać nos",
        de: "to blow your nose",
      },
      {
        pl: "myć zęby",
        de: "to brush your teeth",
      },
      {
        pl: "klaskać",
        de: "to clap your hands",
      },
      {
        pl: "czesać włosy",
        de: "to comb your hair",
      },
      {
        pl: "założyć ręce",
        de: "to fold your arms",
      },
      {
        pl: "trzymać kogoś rękę",
        de: "to hold someone`s hand",
      },
      {
        pl: "kiwać głową na tak",
        de: "to nod your head",
      },
      {
        pl: "kiwać głową na nie",
        de: "to shake your head",
      },
      {
        pl: "podnieść brwi",
        de: "to raise your eyebrows",
      },
      {
        pl: "uścisnąć z kims dłoń",
        de: "to shake hands with someone",
      },
      {
        pl: "źuć (np. gumę)",
        de: "to chew",
      },
      {
        pl: "puścić oko (do kogoś)",
        de: "to wink",
      },
      {
        pl: "przytulać",
        de: "to hug",
      },
      {
        pl: "drapać",
        de: "to scratch",
      },
      {
        pl: "machać (np. ręką)",
        de: "to wa",
      },
      {
        pl: "uklęknąć",
        de: "to kneel down",
      },
      {
        pl: "marszyć brwi",
        de: "to frown",
      },
      {
        pl: "gapić się na ..",
        de: "to stare at",
      },
      {
        pl: "ziewać",
        de: "to yawn",
      },
      {
        pl: "rozciągać się",
        de: "to stretch",
      },
      {
        pl: "wskazywać na",
        de: "to point at",
      },
      {
        pl: "guma do żucia",
        de: "chewing gum",
      },
      {
        pl: "dziąsło",
        de: "gum",
      },
      {
        pl: "pomoóc (dać pomocną dłoń)",
        de: "to lend a hand",
      },
      {
        pl: "strzelić gafę, chlapnąć (coś), palnąć (coś)",
        de: "to put your foot in it",
      },
      {
        pl: "zrobić kogoś w konia, nabrać kogoś",
        de: "pull somebody`s leg",
      },
      {
        pl: "mieć coś na końcu języka",
        de: "to have something on the tip of your tongue",
      },
      {
        pl: "przestraszyć się, stchórzyć",
        de: "to get cold feet",
      },
    ],
  },
];

const ZDANIA18 = [
  {
    name: "[5klasa] Niemiecki : Mod. 4 Kap. 1",
    passwd_API_KEY: "AIzaSyDZQ8Y4ZQ8ZQ8ZQ8ZQ8ZQ8ZQ8ZQ8ZQ8ZQ8",
    zdania: [
      {
        pl: "biegać",
        de: "joggen",
      },
      {
        pl: "grać w piłkę",
        de: "Fußball spielen",
      },
      {
        pl: "jeździć na rolkach",
        de: "inlineskaten",
      },
      {
        pl: "jeździć na rowerze",
        de: "rad fahren",
      },
      {
        pl: "jeździć na nartach",
        de: "Ski fahren",
      },
      {
        pl: "grać w tenis",
        de: "Tennis spielen",
      },
      {
        pl: "sufrować",
        de: "surfen",
      },
      {
        pl: "jeździć na koniu",
        de: "reiten",
      },
      {
        pl: "grać w sitatkówke",
        de: "Volleyball spielen",
      },
      {
        pl: "pływać",
        de: "schwimmen",
      },
      {
        pl: "Jakie jest Twoje hobby?",
        de: "Was ist dein Hobby?",
      },
      {
        pl: "Moje hobby to grać w siatkówkę",
        de: "Mein Hobby ist Volleyball spielen",
      },
      {
        pl: "Stefan, czy umiesz jeździc na rolkach?",
        de: "Stefan, kannst du inlineskaten?",
      },
      {
        pl: "Tak, bardzo dobrze umiem jeździć na rolkach",
        de: "Ja, ich kann sehr gut inlineskaten?",
      },
      {
        pl: "kurs pływania",
        de: "Schwimmkurs",
      },
      {
        pl: "kur jeździecki/jazdy na koniu",
        de: "reitkurs",
      },
      {
        pl: "Czy chcesz iść w Poniedziałek po południu do klubu Tenisowego?",
        de: "Möchtest du am Montagnachmittag in den Tennisclub gehen?",
      },
      {
        pl: "nauka serfowania / kurs serfowania",
        de: "Surfkurs",
      },
      {
        pl: "nauka tenisa / kurs tenisa",
        de: "Tenniskurs",
      },
      {
        pl: "kurs narciarski",
        de: "Skikurs",
      },
      {
        pl: "nauka tańa / kurs tańca",
        de: "tanzkurs",
      },
      {
        pl: "kurs muzyczny, np. grania",
        de: "Musikkurs",
      },
      {
        pl: "On umie dobrze jeździć na rolkach",
        de: "Er kann gut inlineskaten",
      },
      {
        pl: "W Sobotę przed południem chcę iść na siatkówkę",
        de: "Am Samstagvormittag möchte ich Volleyball spielen",
      },
      {
        pl: "Kto musi uczyć się jeździć na nartach?",
        de: "Wer muss Ski fahren lernen?",
      },
      {
        pl: "Ona nie umie jezdzic kono",
        de: "Sie kann nicht reiten",
      },
      {
        pl: "W czwartek wieczorem",
        de: "Am Donnerstagabend",
      },
      {
        pl: "Czy umiesz się wspinać?",
        de: "Kannst du klettern?",
      },
      {
        pl: "Nie, ale chcę się tego nauczyć",
        de: "Nein, aber ich will es Lernen",
      },
      {
        pl: "W takim razie musisz wziąć udział w kursie wspinaczki",
        de: "Dann musst du einen Kletterkurs besuchen ",
      },
      {
        pl: "Czy chciałaby Pani nauczuć się jeździć na rolkach?",
        de: "Möchten Sie Inlineskaten lernen?",
      },
      {
        pl: "Kiedy musisz iść na kurs muzyczny?",
        de: "Wann muss du einen Musikkurs besuchen?",
      },
      {
        pl: "Kiedy chciałbyś/chciałabyś uczestniczyć w zajęciach tanecznych?",
        de: "Wann möchtest du an einem Tanzkurs besuchen?",
      },
      {
        pl: "Chciałbym brać udział w kursie jazdy konnej, ponieważ nie potrafię jeździć konno",
        de: "Ich will an einem Reitkurs denn ich kann nicht reiten",
      },
      {
        pl: "mróz",
        de: "der Frost",
      },
      {
        pl: "weekend",
        de: "das Wochenende",
      },
      {
        pl: "Ćwiczenie zdań",
        de: "Sätze üben",
      },
      {
        pl: "ani trochę",
        de: "gar nicht",
      },
      {
        pl: "nie przesadza",
        de: "überhobt nicht",
      },
      {
        pl: "Co musi zrobić?",
        de: "Was muss er machen?",
      },
      {
        pl: "Oczywiście musi wziąć udział w kursie tenisa",
        de: "Er muss natürlich einen Tenniskur besuchen",
      },
      {
        pl: "Nie, niestety nie mogę grać w tenisa",
        de: "Nein ich kann leider nich Tennis spielen",
      },
      {
        pl: "osoba",
        de: "die Person",
      },
      {
        pl: "chłopak",
        de: "der Junge",
      },
      {
        pl: "należeć",
        de: "gehören",
      },
      {
        pl: "Do kogo należy rower?",
        de: "Wem gehört das Fahrrad?",
      },
      {
        pl: "rower",
        de: "das Fahrrad",
      },
      {
        pl: "torba sportowa",
        de: "die Sporttasche",
      },
      {
        pl: "telefon komórkowy",
        de: "das Handy",
      },
      {
        pl: "rakieta tenisowa",
        de: "der Tennisschläger",
      },
      {
        pl: "Czy rower należy do Stefana?",
        de: "Gehört das Fahrrad Stefan?",
      },
      {
        pl: "Czy te rolki należą do Anny?",
        de: "Gehören die Inlineskates Anna?",
      },
      {
        pl: "Czy ta komórka należy do Tiny?",
        de: "Gehört das Handy Tina?",
      },
      {
        pl: "Nie ono (das handy) nie należy do Tiny. Ono należy do Anny.",
        de: "Nein, es gehört nicht Tina. Es gehört Anna.",
      },
      {
        pl: "Czy to są twoje rolki?",
        de: "Ist das deine Inlineskates?",
      },
      {
        pl: "Nie, to nie są moje rolki. To są rolki Anny.",
        de: "Nein, das ich nicht meine Inlineskates. Das sind die Inlineskates von Anna.",
      },
      {
        pl: "Nie, to nie jest moja hulajnoga. To jest hulajnoga Stefana.",
        de: "Nein, das ist nicht mein Roller. Das ist der Roller von Stefan.",
      },
      {
        pl: "To jest moja hulajnoga.",
        de: "Das ist mein Roller.",
      },
      {
        pl: "To jest moja torba sportowa.",
        de: "Das ist meine Sporttasche.",
      },
      {
        pl: "To jest mój rower.",
        de: "Das ist mein Fahrrad.",
      },
      {
        pl: "To są moje narty.",
        de: "Das sind meine Skier",
      },
      {
        pl: "Czy telefon jest Markusa?",
        de: "Gehört das Handy Markus?",
      },
      {
        pl: "Nie to nie jest jego telefon",
        de: "Nein, das ist nicht sein Handy.",
      },
      {
        pl: "Czy to są Jeansy Brigitte?",
        de: "Gehören die Jeans Brigitte?",
      },
      {
        pl: "Nie, to nie są jej Jeansy.",
        de: "Nein, das sind nicht ihre Jeans.",
      },
      {
        pl: "Czy to jest kurtka z kapturem  Stefana?",
        de: "Gehört der Anorak Stefan?",
      },
      {
        pl: "Nie, to nie jest jego kurtka z kapture (na przykład narciarska).",
        de: "Nein, das ist nicht sein Anorak.",
      },
      {
        pl: "Czy to jest czapka z daszkiem (kaszkiet) Stefana?",
        de: "Gehört der Schirmmütze Stefan?",
      },
      {
        pl: "Nie, to nie jest jego czapka z daszkiem (kaszkiet).",
        de: "Nein, das ist nicht sein Schirmmütze.",
      },
      {
        pl: "Kurtka",
        de: "die Jacke",
      },
      {
        pl: "wczoraj",
        de: "gestern",
      },
      {
        pl: "potem",
        de: "dann",
      },
      {
        pl: "W poniedziałek po południu oglądate film",
        de: "Am Montatnachmittag sehe ich einen Film.",
      },
      {
        pl: "We wtorek rano idę płwyać z kolegami",
        de: "Am Dienstagmorgen gehe ich mit Freunden schwimmen.",
      },
      {
        pl: "W środę wieczorem tańcześ z przyjacielami",
        de: "Am Mittwochabend tanze ich mit Freunden.",
      },
      {
        pl: "W piątek rano idę grać w piłkę nożną na boisko",
        de: "Am Freitagmorgen gehe ich mit Freunden Fußball spielen auf dem Platz.",
      },
      {
        pl: "Czy potrafisz grać w piłkę?",
        de: "Kannst du Fußball spielen?",
      },
      {
        pl: "Czy ona umie jeździć na rolkach?",
        de: "Kann sie Inlineskates fahren?",
      },
      {
        pl: "Czy oni potrafią jeździć na nartach?",
        de: "Können sie Ski fahren?",
      },
      {
        pl: "Czy potraficie grać w tenisa?",
        de: "Können Sie Tennis spielen?",
      },
      {
        pl: "Osoba",
        de: "die Person",
      },
      {
        pl: "Ludzie",
        de: "die Personen",
      },
      {
        pl: "dziewczyna",
        de: "das Mädchen",
      },
      {
        pl: "dziewczyny",
        de: "die Mädchen",
      },
      {
        pl: "Markus, czy mogę wziąć twoją komórkę?",
        de: "Markus, kann ich mal dein Handy haben?",
      },
      {
        pl: "Tak, oczywiście proszę",
        de: "Ja, natürlich, bitte",
      },
      {
        pl: "Dziękuję. Jesteś bardzo miły.",
        de: "Danke. Du bist sehr nett",
      },
      {
        pl: "Brigitte, czy mogę wziąć twoje buty sportowe?",
        de: "Brigitte, kann ich mal deine Sportschuhe haben?",
      },
      {
        pl: "Stefan, czy mogę wziąć twoją czapkę z daszkiem?",
        de: "Stefan, kann ich mal deine Schirmmütze haben?",
      },
      {
        pl: "Anna, czy mogę wziąć twoje rolki?",
        de: "Anna, kann ich mal deine Inlineskates haben?",
      },
      {
        pl: "Czy mogę wziąć twoje narty?",
        de: "Kann ich mal deine Skier haben?",
      },
      {
        pl: "Czy mogę wziąć twoją kurtkę z kapturem?",
        de: "Kann ich mal deine Anorak haben?",
      },
      {
        pl: "Czy mogę wziąć twoją torbę sportową?",
        de: "Kann ich mal deine Sporttasche haben?",
      },
      {
        pl: "Czy mogę wziąć twoje nozyczki?",
        de: "Kann ich mal deine Schere haben?",
      },
      {
        pl: "Czy mogę wziąć twoją strugawkę?",
        de: "Kann ich mal deine Spitzel haben?",
      },
      {
        pl: "moje buty sportowe",
        de: "meine Sportschuhe",
      },
      {
        pl: "twoj rower",
        de: "dein Fahrrad",
      },
      {
        pl: "jej czapka z daszkiem",
        de: "ihre Schirmmütze",
      },
      {
        pl: "Co szuka Markus?",
        de: "Was sucht Markus?",
      },
      {
        pl: "On szuka jego hulajnogi",
        de: "Er sucht seinen Roller",
      },
      {
        pl: "Co szuka Brigitte?",
        de: "Was sucht Brigitte?",
      },
      {
        pl: "Ona szuka jej butów sportowych",
        de: "Sie sucht ihre Sportschuhe",
      },
      {
        pl: "Co szuka Stefan?",
        de: "Was sucht Stefan?",
      },
      {
        pl: "On szuka jego czapki z daszkiem",
        de: "Er sucht seine Schirmmütze",
      },
      {
        pl: "Ona szuka swój telefon",
        de: "Sie sucht ihr Handy",
      },
      {
        pl: "Ona szuka jej butów sportowych",
        de: "Sie sucht ihre Sportschuhe",
      },
      {
        pl: "Ona szuka jej rolek",
        de: "Sie sucht ihre Inlineskates",
      },
      {
        pl: "Ona szuka jej piłki",
        de: "Sie sucht ihren Ball",
      },
      {
        pl: "ona szuka jej strugawki",
        de: "Sie sucht ihren Spitzel",
      },

      {
        pl: "Nie moge znaleźć mojego telefonu. Gdzie on jest zatem?",
        de: "Ich kann mein Handy nicht finden. Wo ist es denn?",
      },
      {
        pl: "Ona szuka jej butów sportowych. Gdzie one są zatem?",
        de: "Sie sucht ihre Sportschuhe. Wo sind sie denn?",
      },
      {
        pl: "Czy to jest twoja kurtka z kapturem?",
        de: "Ist das deine Anorak?",
      },
      {
        pl: "Nie, moja kurtka z kapturem nie jest niebieska, lecz czarna",
        de: "Nein, meine Anorak ist blau, sondern schwarz",
      },
      {
        pl: "Hurra, mam twojego białego t-shirt znów",
        de: "Hurra, ich habe dein weißes T-Shirt wieder da",
      },
      {
        pl: "Przykro mi, ale nie widzę twojego zółtego telefonu",
        de: "Es tut mir leid, aber ich sehe dein gelbes Handy nicht",
      },
      {
        pl: "zegarek",
        de: "die Uhr",
      },
      {
        pl: "jeansy",
        de: "die Jeans",
      },
      {
        pl: "spudniczka",
        de: "der Rock",
      },
      {
        pl: "spodnie",
        de: "die Hose",
      },
      {
        pl: "czapka z daszkiem",
        de: "die Schirmmütze",
      },
      {
        pl: "sweter",
        de: "der Pulli",
      },
      {
        pl: "Ona ma swoje zeszyty",
        de: "Sie hat ihr Hefte",
      },
      {
        pl: "Czy Pani ma swoją pilke?",
        de: "Haben Sie Ihren Ball?",
      },
      {
        pl: "Tam są Wasze książki",
        de: "Dort sind eure Bücher",
      },
      {
        pl: "Gdzie jest twój długopis?",
        de: "Wo ist dein Kuli?",
      },
      {
        pl: "My potrzebujemy naszej gumki",
        de: "Wir brauchen unsere radiergummi",
      },
      {
        pl: "On szuka swojego roweru",
        de: "Er sucht sein Fahrrad",
      },
      {
        pl: "siostry bliźniaczki",
        de: "die Zwillingsschwestern",
      },
      {
        pl: "bracia bliźniacy",
        de: "die Zwillingsbrüder",
      },
      {
        pl: "lecz",
        de: "sondern",
      },
      {
        pl: "On szuka torby sportowej",
        de: "Er sucht die Sporttasche",
      },
    ],
  },
];

export { ZDANIA17, ZDANIA18 };
